import { css, fillOutlined, circle } from './draw-utils';
import type { ProceduralDef } from '../types';

const HULL = 0x2a3340; // dark cloaked hull
const EDGE = 0x45d9c5; // cyan running light

/**
 * Stalker — a sleek cloaked hunter (arrowhead). Frame 0 cloaked-dim /
 * 1 revealed (ambush). docs/02 boss pool.
 */
export const bossStalkerBody: ProceduralDef = {
  key: 'boss/stalker/body',
  width: 130,
  height: 130,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const lit = frame === 1;

    if (lit) {
      const halo = ctx.createRadialGradient(c, c, 14, c, c, c);
      halo.addColorStop(0, 'rgba(69,217,197,0.35)');
      halo.addColorStop(1, 'rgba(69,217,197,0)');
      circle(ctx, c, c, c);
      ctx.fillStyle = halo;
      ctx.fill();
    }

    // Arrowhead hull pointing up (rotated in code to face travel)
    ctx.beginPath();
    ctx.moveTo(c, c - 50);
    ctx.lineTo(c + 34, c + 26);
    ctx.lineTo(c, c + 12);
    ctx.lineTo(c - 34, c + 26);
    ctx.closePath();
    fillOutlined(ctx, HULL, 5);

    // Edge running lights
    ctx.strokeStyle = css(EDGE);
    ctx.lineWidth = lit ? 3 : 2;
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(c, c - 44);
    ctx.lineTo(c + 28, c + 22);
    ctx.moveTo(c, c - 44);
    ctx.lineTo(c - 28, c + 22);
    ctx.stroke();

    // Sensor eye
    circle(ctx, c, c - 18, lit ? 8 : 6);
    ctx.fillStyle = css(lit ? 0xeafff8 : EDGE);
    ctx.fill();
    void h;
  },
};
